import React from 'react';
import classNames from 'classnames';

export type ButtonVariant = 'primary';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant | '';
  size?: 'small' | 'normal';
  processing?: boolean | null;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  variant,
  size = 'normal',
  processing,
  className,
  children,
  ...props
}, ref) => {
  return (
    <button
      ref={ref}
      className={classNames(
        'button',
        {
          'is-loading': processing,
          'is-primary': variant === 'primary',
          'is-small': size === 'small',
        },
        className
      )}
      role="row"
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = 'Button';
